<script setup>
import { computed } from 'vue'
import BaseImage from '@/components/BaseImage.vue'

const props = defineProps({
  block: { type: Object, required: true },   // { images: [{src, alt, caption}], columns }
})

const images = computed(() => props.block.images || [])
const columns = computed(() => props.block.columns || images.value.length || 1)

// Single wide image reads as 16/9; multi-up thumbnails as 4/3 (matches Figma).
const ratio = computed(() => (columns.value === 1 ? '16/9' : '4/3'))
</script>

<template>
  <div class="figure-block" :style="{ '--cols': columns }">
    <figure v-for="(img, i) in images" :key="i" class="figure">
      <BaseImage :src="img.src" :alt="img.alt || ''" :aspect-ratio="ratio" fit="cover" />
      <figcaption v-if="img.caption" class="caption">{{ img.caption }}</figcaption>
    </figure>
  </div>
</template>

<style lang="scss" scoped>
.figure-block {
  display: grid;
  grid-template-columns: 1fr;
  gap: $space-5;

  @include from-md {
    grid-template-columns: repeat(var(--cols), 1fr);
  }

  .figure {
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: $space-3;

    .caption {
      font-size: $font-size-sm;
      line-height: $lh-base;
      color: var(--color-text-muted);
    }
  }
}
</style>
